module.exports = __webpack_public_path__ + "img/EIRIKSSON_m.6d33a4f7.png";